import { Login } from './Login';

export type { TypeLoginProps } from './types';
export default Login;
